import react, { useState } from "react";
import styles from "./Accordion.module.scss";
import {
  Accordion as SomeAccordion,
  useAccordionToggle,
  Col
} from "../DependencyHelper";

export const Accordion = SomeAccordion;

export const AccordionItem = props => {
  const [activeAccordion, setActiveAccordion] = useState("");

  const toggleClass = eventKey => {
    return props.activeAccordion === eventKey
      ? `toggle--active ${styles["accordion__toggle--active"]}`
      : "";
  };

  const CustomToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionToggle(eventKey, () => {
      if (eventKey === activeAccordion) {
        setActiveAccordion("");
      } else {
        setActiveAccordion(eventKey);
      }
    });

    return (
      <div
        className={`${styles["accordion__toggle"]} ${
          props.className
          } ${toggleClass(eventKey)}`}
          id={props.id}
        onClick={() => {
          decoratedOnClick();
          props.handleOnClick(eventKey);
        }}
        id={props.id?props.id:"accordion"}
      >
        {children}
      </div>
    );
  };

  return (
    <div className={styles["accordion"]} id={props.id} data-cms-title={props.dataCMSTitle}>
      <Col xs={12}>
        <CustomToggle eventKey={props.eventKey}>{props.title}</CustomToggle>
      </Col>
      <Accordion.Collapse eventKey={props.eventKey}>
        <div className={styles["accordion__collapse"]}>
          <Col xs={12}>{props.children}</Col>
        </div>
      </Accordion.Collapse>
    </div>
  );
};
